var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.paymentPlan
      ? _c(
          "div",
          [
            _c(
              "h2",
              { attrs: { tabindex: "-1" } },
              [
                _c("plain-text-control", {
                  attrs: { title: "PaymentPlan.Information.Title" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("dl", { attrs: { id: "paymentPlanDescription" } }, [
              _c(
                "dd",
                [
                  _c("text-label-row", {
                    attrs: {
                      title: "PaymentPlan.Information.AidTargetNumber",
                      labelClass: "col-9 col-sm-6 col-md-5 col-xl-3",
                      valueClass: "col-3",
                      value: _vm.aidTargetNumber,
                      alignRight: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("text-label-row", {
                    attrs: {
                      title: "PaymentPlan.Information.WithdrawableAmountTotal",
                      labelClass: "col-9 col-sm-6 col-md-5 col-xl-3",
                      valueClass: "col-3",
                      formatNumber: true,
                      value: _vm.availableAmount.toString(),
                      sign: "€",
                      alignRight: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("dd", [
                _vm.aidYearAmounts
                  ? _c(
                      "div",
                      _vm._l(_vm.aidYearAmounts, function(
                        aidYearAmount,
                        index
                      ) {
                        return _c("aid-year-amount-row", {
                          key: _vm.aidAmountKeys[index],
                          attrs: {
                            title: _vm.getAidYearAmountTitle(aidYearAmount),
                            doNotUseResources: true,
                            labelClass: "col-9 col-sm-6 col-md-5 col-xl-3",
                            valueClass: "col-3",
                            formatNumber: true,
                            value: aidYearAmount.availableAmount.toString(),
                            rules: _vm.validateAmount
                              ? { min_value: aidYearAmount.availableAmount }
                              : null,
                            valueToValidate: _vm.amountSpentByDate(
                              aidYearAmount
                            ),
                            validate: _vm.validateAmount,
                            sign: "€",
                            alignRight: true
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("value-display-row", {
                    attrs: {
                      title: "PaymentPlan.Information.UnplannedAmount",
                      labelClass: "col-9 col-sm-6 col-md-5 col-xl-3",
                      valueClass: "col-3",
                      formatNumber: true,
                      value: _vm.remainingAvailableAmount,
                      rules: { is: 0 },
                      validate: true,
                      sign: "€",
                      alignRight: true
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("payment-plan-table", {
              attrs: {
                id: "paymentplanrequests",
                requests: _vm.paymentPlan.plannedRequests,
                totals: _vm.requestsTotal,
                earliestPaymentDate: _vm.earliestPaymentDate,
                latestPaymentDate: _vm.latestPaymentDate
              },
              on: {
                dateChanged: function($event) {
                  return _vm.refreshAidAmountValidation()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "h2",
              { staticClass: "mt-5", attrs: { tabindex: "-1" } },
              [
                _c("plain-text-control", {
                  attrs: {
                    id: "additionalinformation_header",
                    title: "PaymentPlan.AdditionalInformation"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                id: "additionalinformation",
                required: false,
                maxLength: 500,
                rows: 5,
                inputWidth: "col-12 col-sm-9 col-md-8 col-xl-6",
                ariaLabelId: "additionalinformation_header"
              },
              model: {
                value: _vm.paymentPlan.additionalInformation,
                callback: function($$v) {
                  _vm.$set(_vm.paymentPlan, "additionalInformation", $$v)
                },
                expression: "paymentPlan.additionalInformation"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row form-group", staticStyle: { "margin-left": "0" } },
      [
        _c("div", {
          staticClass: "col-12 col-sm-9 col-md-8 col-xl-6",
          staticStyle: { "border-bottom": "2px solid black" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }